import React,{useState,useEffect} from 'react';
import Layout from '../main/Layout/Layout';
import axios from 'axios';
import Spinner from '../main/Spinner/Spinner';
import {isAuthenticated} from '../auth/authenticate';


function AddProduct(props) {
    const [values,setValues] =useState({
        name: '',
        description: '',
        price: '',
        categories: [],
        category: '',
        shipping: '',
        quantity: '',
        image: '',
        loading: false,
        error: '',
        createdProduct: '',
        redirectToProfile: false,
        formData: ''
    })
    const {name,description,price,categories,quantity,loading,error,createdProduct,formData} =values;
    const getCategorys =()=>{
        axios.get('/categorys')
        .then(cats=>{
           return setValues({...values,categories:cats.data.cates,formData:new FormData()})
        }).catch(err=>{
           return setValues({...values,error:err.response.data.message})
        });
    };

    useEffect(()=>{
        getCategorys();
    },[])

    const handleChange =name=>event=>{
        const value = name==='image'?event.target.files[0]:event.target.value;
        formData.set(name, value);
        setValues({...values,error:false,createdProduct:false,[name]:value});
    };
    const clickSubmit = event=>{
        event.preventDefault();
        setValues({...values,loading:true,error:""});
        const options = {
            url:'/product/create',
            method: 'POST',
            headers: { Authorization: 'Bearer ' + isAuthenticated().data.token },
            data: formData,// This is the body part
          };
        axios(options)
        .then(data=>{
            // console.log(data)
            setValues({...values,redirectToProfile:true,loading: false,createdProduct:data.data.result.name,name:"",description:"",price:"",category:"",shipping:"",quantity:""});
        }).catch(err=>{
            setValues({...values,error:err.response.data.message});
        })
    };

    const showError = () => (
        <div className="alert alert-danger" style={{ display: error ? '' : 'none' }}>
            {error}
        </div>
    );

    const showSuccess = () => (
        <div className="alert alert-info" style={{ display: createdProduct ? '' : 'none' }}>
            <h2>{`${createdProduct}`} is created!</h2>
        </div>
    );

    const showLoading = () =>
        loading && (
            <Spinner/>
        );

    return (
        <React.Fragment>
        <Layout/>
        <br/>
        <div className="container" style={{backgroundColor:"#e5e5e5",borderRadius:"10px"}}>
            <form className="my-5 p-4">
                {showError()}
                {showSuccess()}
                {showLoading()}
            <h4>Post Photo</h4>
            <div className="form-group">
                <label className="btn btn-secondary">
                    <input onChange={handleChange('image')} type="file"  name="image" accept="image/*" />
                </label>
            </div>
            <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input id ="name" onChange={handleChange('name')} value={name} type="text"  className="form-control" placeholder="add product name"/>
            </div>
            <div className="form-group">
                    <label htmlFor="des">Description</label>
                    <textarea rows="5" id ="des" onChange={handleChange('description')} value={description} type="text"  className="form-control" placeholder="add product description"/>
            </div>
            <div className="form-group">
                <label htmlFor="price">Price</label>
                <input id="price" onChange={handleChange('price')} type="number" className="form-control" value={price} />
            </div>
            <div className="form-group">
                <label htmlFor="cat">Category</label>
                <select id="cat" onChange={handleChange('category')} className="form-control">
                    <option>Please select</option>
                    {categories &&
                        categories.map((c, i) => (
                            <option key={i} value={c._id}>
                                {c.name}
                            </option>
                        ))}
                </select>
            </div>

            <div className="form-group">
                <label htmlFor="ship">Shipping</label>
                <select id="ship" onChange={handleChange('shipping')} className="form-control">
                    <option>Please select</option>
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                </select>
            </div>

            <div className="form-group">
                <label htmlFor="qt">Quantity</label>
                <input id="qt" onChange={handleChange('quantity')} type="number" className="form-control" value={quantity} />
            </div>
                <button onClick={clickSubmit} className="btn btn-primary">Create Product</button>
            </form>
        </div>
    </React.Fragment>
    );
}

export default AddProduct;